import { render, staticRenderFns } from "./question2.vue?vue&type=template&id=1bd9308e&"
import script from "./question2.vue?vue&type=script&lang=js&"
export * from "./question2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports